import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { WA_URL } from "../config/constants";
import { TEAM } from "../data/team";
import "./About.css";

export default function About() {
  const { t } = useTranslation("about");

  const values = t("values", { returnObjects: true });

  return (
    <main>
      <Helmet>
        <title>About Us — ProNet Real Estate Dubai</title>
        <meta name="description" content="ProNet Real Estate is a Dubai-based agency with 12+ years of experience specialising in residential and commercial properties across the UAE. Meet our team." />
        <link rel="canonical" href="https://pronet-realestate.com/about" />
        <meta property="og:title" content="About Us — ProNet Real Estate Dubai" />
        <meta property="og:description" content="ProNet Real Estate is a Dubai-based agency with 12+ years of experience specialising in residential and commercial properties across the UAE." />
        <meta property="og:url" content="https://pronet-realestate.com/about" />
        <meta property="og:type" content="website" />
      </Helmet>

      <section className="about-hero">
        <div className="container">
          <div className="about-eyebrow">{t("hero.eyebrow")}</div>
          <h1 className="about-title">{t("hero.title")}<br /><em>{t("hero.titleEm")}</em></h1>
        </div>
      </section>

      <section className="team-section">
        <div className="container">
          <div className="team-hd">
            <div className="about-eyebrow">{t("team.eyebrow")}</div>
            <h2 className="team-title">{t("team.title")} <em>{t("team.titleEm")}</em></h2>
            <p className="team-sub">{t("team.sub")}</p>
          </div>

          <div className="team-grid">
            {TEAM.map((m) => (
              <div key={m.name} className="team-card">
                <div className="team-photo-wrap">
                  <img src={m.photo} alt={m.name} className="team-photo" loading="lazy" style={{ objectPosition: m.pos }} />
                </div>
                <div className="team-info">
                  <h3 className="team-name">{m.name}</h3>
                  <p className="team-role">{t("team.role")}</p>
                  <div className="team-contacts">
                    <a href={`tel:${m.phone.replace(/\s/g, "")}`} className="team-contact">
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 01.22 2.18 2 2 0 012.18 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.18 6.18l1.28-1.28a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
                      {m.phone}
                    </a>
                    <a href={`mailto:${m.email}`} className="team-contact">
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 7l10 7 10-7"/></svg>
                      {m.email}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="container about-body">
        <div className="about-text">
          <p>{t("body.p1")}</p>
          <p>{t("body.p2")}</p>
          <p>{t("body.p3")}</p>
        </div>
        <div className="about-vals">
          {values.map((v, i) => (
            <div key={i} className="val-card">
              <div className="val-num">0{i + 1}</div>
              <div className="val-title">{v.title}</div>
              <p className="val-desc">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="about-cta">
        <div className="container">
          <div className="about-cta-inner">
            <div>
              <h2>{t("cta.title")} <em>{t("cta.titleEm")}</em></h2>
              <p>{t("cta.sub")}</p>
            </div>
            <div className="about-cta-btns">
              <a href={WA_URL} target="_blank" rel="noreferrer" className="btn-gold">WhatsApp</a>
              <Link to="/contact" className="btn-outline">{t("cta.send")}</Link>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
